import { components } from 'services/api/lna-api-v2.schema';

export type FileCard = components['schemas']['FileCard'];
export type FileNoteCard = components['schemas']['FileNoteCard'];
export type UpdateFileNoteRequest = components['schemas']['BackofficeUpdateFileNoteRequest'];

export const FILE_OBJECT_TYPE_DOCTORAL = 'DoctoralCertificate';
export const FILE_OBJECT_TYPE_RESEARCH_TOPIC = 'TopicFile';
export const FILE_OBJECT_TYPE_RESEARCH_TOPIC_JUSTIFICATION = 'TopicJustification';
export const FILE_OBJECT_TYPE_EVENT = 'Event';
export const FILE_OBJECT_TYPE_CLIENT_NOTE = 'ClientNoteFile';
export const FILE_OBJECT_TYPE_SUMBISSION_NOTE = 'ReadingRoomSubmissionNoteFile';
export const FILE_OBJECT_TYPE_PRINTOUT_TEMPLATE = 'PrintoutTemplate';
export const FILE_OBJECT_TYPE_COMMUNICATION_BACKOFFICE = 'ReadingRoomSubmissionCommunicationBackoffice';
export const FILE_OBJECT_TYPE_COMMUNICATION_FRONTOFFICE = 'ReadingRoomSubmissionCommunicationFrontoffice';
export const FILE_OBJECT_TYPE_TOOLTIP = 'TooltipFile';
export const FILE_OBJECT_TYPE_LEGAL_ENTITY_NOTE = 'LegalEntityNoteFile';

export const FILE_TERM_TYPE_UNKNOWN = 'Unknown';
export const FILE_TERM_TYPE_FIXED = 'Fixed';
export const FILE_TERM_TYPE_INDEFINITE = 'Indefinite';

export interface FileToAdd extends File {
  description: string;
  backofficeNote: string;
  validTill: string;
  termType: string;
}

export type FileObjectType =
  | 'Test'
  | 'DoctoralCertificate'
  | 'TopicFile'
  | 'TopicJustification'
  | 'ReadingRoomSubmissionDoctoralCertificate'
  | 'ClientNoteFile'
  | 'ReadingRoomSubmissionCommunicationBackoffice'
  | 'ReadingRoomSubmissionCommunicationFrontoffice'
  | 'ReadingRoomSubmissionNoteFile'
  | 'LegalEntityNoteFile';
